import React, { useState, useEffect } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter"; // , {textFilter, selectFilter, dateFilter,}
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit"; // , { Search, CSVExport,}
// import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
// import { toast } from "react-toastify";
import {
  Row,
  Col,
  // Form, Button, FormControl
} from "react-bootstrap";
// import { CSVLink } from "react-csv";
const { ExportCSVButton } = CSVExport;

// Import Service
// import factoryService from "../../services/factory.service";
// import authService from "../../services/auth.service";
// import farmerService from "../../services/farmer.service";

//Import Loading
import Spinner from "react-bootstrap/Spinner";
import FactoryService from "../../services/factory.service";
// import { confirmAlert } from "react-confirm-alert";
// import LoadingAlert from "../../components/LoadingAlert";

// Import Modal
// import ModalViewDetail from "./modalViewMembers";
// import ModalAddFactory from "./modalAddFactory";
// import ModalEditFactory from "./modalEditFactory";
// import ModalCheckMember from "./modalCheckMember";
// import MemberForm from "./formMember";

//Import tooltip
// import OverlayTrigger from "react-bootstrap/OverlayTrigger";
// import Tooltip from "react-bootstrap/Tooltip";

const SugarcaneProducts = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const getData = () => {
    setLoading(true);
    FactoryService.getSugarcaneProduct()
      .then((response) => {
        if (response.data.success) {
          setData(response.data.data);
        }
      })
      .catch((err) => alert(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getData();
    // getFactory();
    // setLoading(false);
  }, []);

  const dateFormatter = (cell) => {
    const getdate = new Date(cell);
    return (
      <p>
        {getdate.toLocaleString("th-TH", {
          year: "2-digit",
          month: "short",
          day: "numeric",
        })}
      </p>
    );
  };

  const headerSortingStyle = {
    backgroundColor: "#D4EFDF",
    verticalAlign: "center",
  };

  function NumFormatter(number) {
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  const columns = [
    {
      text: "productionid",
      dataField: "productionid",
      sort: true,
      hidden: true,
      csvExport: false,
    },
    {
      text: "รหัสโรงงาน",
      dataField: "factorycode",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      headerSortingStyle,
    },
    {
      text: "ชื่อโรงงาน",
      dataField: "factoryname",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      headerStyle: () => {
        return { textAlign: "center", width: "20%" };
      },
      style: {
        textAlign: "left",
      },
    },
    {
      text: "วันที่เปิด",
      formatter: dateFormatter,
      filterValue: (cell) => {
        const getdate = new Date(cell);
        return getdate.toLocaleString("th-TH", {
          year: "2-digit",
          month: "short",
          day: "numeric",
        });
      },
      dataField: "opendate",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      headerSortingStyle,
    },
    {
      text: "วันที่ปิด",
      formatter: dateFormatter,
      filterValue: (cell) => {
        const getdate = new Date(cell);
        return getdate.toLocaleString("th-TH", {
          year: "2-digit",
          month: "short",
          day: "numeric",
        });
      },
      dataField: "closedate",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      headerSortingStyle,
    },
    {
      text: "อ้อยสด",
      dataField: "freshcane",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      formatter: NumFormatter,
      headerSortingStyle,
    },
    {
      text: "อ้อยไฟไหม้",
      dataField: "burncane",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      formatter: NumFormatter,
      headerSortingStyle,
      style: {
        textAlign: "center",
      },
    },
    {
      text: "รวม",
      dataField: "total",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      formatter: NumFormatter,
      headerSortingStyle,
      style: {
        textAlign: "center",
      },
    },
    {
      text: "ค่า ccs",
      dataField: "ccs",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      formatter: NumFormatter,
      headerSortingStyle,
      style: {
        textAlign: "center",
      },
    },
    {
      text: "ร้อยละอ้อยไฟไหม้",
      dataField: "burn_",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      formatter: NumFormatter,
      headerSortingStyle,
      style: {
        textAlign: "center",
      },
    },
    {
      text: "ผลผลิตน้ำตาลรวม",
      dataField: "sugartotal",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      formatter: NumFormatter,
      headerSortingStyle,
      style: {
        textAlign: "center",
      },
    },
    {
      text: "ประสิทธิภาพการผลิตน้ำตาล",
      dataField: "sugarofcane",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      formatter: NumFormatter,
      headerSortingStyle,
      style: {
        textAlign: "center",
      },
    },

    // {
    //   text: "แก้ไข",
    //   dataField: "edit",
    //   isDummyField: true,
    //   editable: false,
    //   formatter: actionsViewFormatter,
    //   headerStyle: () => {
    //     return { textAlign: "center", width: "10%" };
    //   },
    //   headerSortingStyle,
    // },
  ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 10,
    firstPageText: "|<",
    lastPageText: ">|",
    nextPageText: ">>",
    prePageText: "<<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
  });

  if (loading)
    return (
      <>
        <p>
          <Spinner animation="border" variant="success" />
          <span>&nbsp;กรุณารอ เนื่องจากข้อมูลมีปริมาณมาก</span>
        </p>
      </>
    );
  // if (error) return `Error :${error}`;

  return (
    <div>
      <ToolkitProvider
        bootstrap4
        keyField="productionid"
        data={data}
        columns={columns}
        search
        exportCSV={{
          fileName: "ข้อมูลน้ำตาลทราย.csv", // "ข้อมูลสมาชิก_" + {cell} + ".csv",
          separator: ",",
          ignoreHeader: false,
          noAutoBOM: false,
          blobType: "text/plain;charset=utf-8",
          onlyExportFiltered: true,
          exportAll: false,
        }}
      >
        {(prop) => (
          <React.Fragment>
            <div>
              <Row>
                <Col md={12}>
                  <ExportCSVButton
                    {...prop.csvProps}
                    style={{
                      padding: ".375rem .75rem",
                      fontSize: "1rem",
                      // float: "right",
                    }}
                  >
                    <i className="bi bi-download"></i>
                  </ExportCSVButton>
                </Col>
              </Row>
            </div>
            <hr />
            <BootstrapTable
              pagination={pagination}
              filter={filterFactory()}
              // headerClasses="header-class"
              {...prop.baseProps}
            />
          </React.Fragment>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default SugarcaneProducts;
